import { cn } from '@repo/tailwind-config/tailwind.functions'
import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'
import Badge from '@repo/ui/badge'
import Box from '@repo/ui/box'
import InnerBox from '@repo/ui/inner-box'
import Typography, { TextType } from '@repo/ui/typography'
import { PropsWithChildren } from 'react'

type BaseProps = {
  icon: SVGFC
  mode?: 'inner-box' | 'box'
  className?: string
}

type StringTitleProps = BaseProps & {
  title: string
  titleColor?: TailwindColor
  titleVariant?: TextType
}

type NodeTitleProps = BaseProps & {
  title: React.ReactNode
  titleColor?: never
  titleVariant?: never
}

type Props = StringTitleProps | NodeTitleProps

const BoxContent = ({
  icon,
  title,
  children,
  titleColor,
  titleVariant
}: PropsWithChildren<Props>) => {
  const Icon = icon

  return (
    <>
      <div className="flex items-center gap-2">
        <Badge
          icon={<Icon color={tailwindColors.primary.DEFAULT} />}
          iconPosition="start"
          color={tailwindColors.primary.light.DEFAULT}
          size="flexible"
          className="rounded"
        />
        {typeof title === 'string' ? (
          <Typography
            variant={titleVariant ?? 'sub-heading'}
            color={titleColor ?? tailwindColors.primary.DEFAULT}
          >
            {title}
          </Typography>
        ) : (
          title
        )}
      </div>
      {children}
    </>
  )
}

const IconBox = ({ className, mode = 'box', ...props }: PropsWithChildren<Props>) => {
  return mode === 'inner-box' ? (
    <InnerBox className={cn('p-4', className)}>
      <BoxContent {...props} />
      <div className="h-3" />
    </InnerBox>
  ) : (
    <Box className={cn('py-6 px-5', className)}>
      <BoxContent {...props} />
    </Box>
  )
}

export default IconBox
